import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'rootcause-paragraph';

const validator = () => null;

const vFParams = {
  paragraph: 'When answering this question consider the "5 Why principle". Ask yourself "why?" 5 times to reach the underlying initial root cause.  For example, the change was not complete on time…WHY?  Because the replacement card failed. WHY? It was the wrong card for the device. WHY? The supplier confirmed it sent the wrong card. WHY? The supplier has an outdated Vodafone equipment list. WHY?  Vodafone hasn’t sent an up-to-date list of network device types. This then becomes the true root cause.Please enter additional information about the reasons for the change being unsuccessful and the impact on customer and services.',
};

const rootcauseParagraph = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { rootcauseParagraph };
